// extracted by mini-css-extract-plugin
export var button = "ArticleNav-module--button--90d6e";
export var container = "ArticleNav-module--container--03b7e";
export var controls = "ArticleNav-module--controls--b7389";
export var dropdown = "ArticleNav-module--dropdown--3b453";
export var heading = "ArticleNav-module--heading--2d666";
export var inner = "ArticleNav-module--inner--2ea89";
export var nav = "ArticleNav-module--nav--4df8e";
export var navActive = "ArticleNav-module--navActive--2e9d5";
export var toggle = "ArticleNav-module--toggle--3252b";